import qs from 'querystring';
import { Icon, Stack } from '@storyofams/react-ui';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Heading } from '~components/common/Heading';
import { Facebook, Linkedin, Pinterest } from '~components/common/Icons';

const messages = defineMessages({
  shareOn: 'Share on',
});

const Button = (props) => (
  <Icon
    as="a"
    target="_blank"
    rel="noopener noreferrer"
    p={0.5}
    fontSize={[1.5, 2.25]}
    {...props}
  />
);

export const ShareButtons = ({ image, description }) => {
  return (
    <>
      <Heading variant="sh4" as="h4" mb={1.5} display={['none', 'block']}>
        <FormattedMessage {...messages.shareOn} />
      </Heading>

      <Stack space={1}>
        <Button
          icon={Facebook}
          href={`https://www.facebook.com/dialog/share?${qs.stringify({
            u: process.browser && window?.location?.href,
            display: 'popup',
          })}`}
        />

        <Button
          icon={Linkedin}
          href={`http://www.linkedin.com/shareArticle?${qs.stringify({
            mini: true,
            url: process.browser && window?.location?.href,
            title: description,
            source: 'social.linkedin',
          })}`}
        />

        <Button
          icon={Pinterest}
          href={`http://www.pinterest.com/pin/create/button/?url=${
            process.browser ? window?.location?.href : ''
          }&media=${image?.filename}&description=${description}`}
        />
      </Stack>
    </>
  );
};
